import { _isNumberValue } from "@angular/cdk/coercion";
import { of } from "rxjs";

/**Groupement d'enregistrements de combo */
export class ComboGroupRecords {
   /**Nom du groupement */
   Label: string;

   /**Code du groupement */
   Code: string;

   /**Liste des enregistrements */
   Records: ComboRecord[] = [];

   constructor(_iCode: string, _iName: string, _iRecords: ComboRecord[]) {
      this.Label = _iName;
      this.Records = _iRecords;
      this.Code = _iCode;
   }

   /**
    * Retourne si présent celui preselectionné
    * @returns 
    */
   public GetPreSelected(): ComboRecord | undefined {
      return this?.Records?.find(t => t && t.Preselected === true);
   }

     /**
    * Retourne si présent selon son id
    * @returns 
    */
   public GetById(_iRecordId:string): ComboRecord | undefined {
      return this?.Records?.find(t => t && t.Id == _iRecordId);
   }

   /**Indique si il dispose de données dans le groupement */
   public Exists(){
      return this?.Records?.length>0;
   }

   /**
    * Attribue la selection à l'enregistrement selon son Id
    * @param _iRecordId id enregistrement
    * @returns 
    */
   public SetPreSelected(_iRecordId: string): boolean {
      if (this.Exists()) {
         this.Records.forEach(r => r.Preselected = r.Id == _iRecordId);
         return this.GetPreSelected() != undefined;
      }
      return false;
   }

    /**
     * Initialise l'objet pour acceder à ces fonctionnalités
     * @param _iJsonComboxRecords 
     */
    static fromJson(_iJsonComboxRecords: ComboGroupRecords[]): ComboGroupRecords[] {
      let oGroupsRecords : ComboGroupRecords[] = [];
      if(_iJsonComboxRecords && _iJsonComboxRecords?.length> 0){
         _iJsonComboxRecords.forEach((fGrp:any)=>{
            oGroupsRecords.push(new ComboGroupRecords(fGrp.Code, fGrp.Label, fGrp.Records));

         })
      }
      return oGroupsRecords;
    }
}

/**Enregistrement de combo */
export class ComboRecord {

   /**Nom de l'enregistrement */
   Label: string;

   /**Nom de l'enregistrement */
   Short: string;

   /**Description de l'enregistrement */
   Description: string;

   /**succession de terme de recherche */
   SearchTerms: string;

   /**Code de l'enregistrement */
   Code: string;
   /**id de l'enregistrement */
   Id: string;

   /**class de l'icone liée */
   Icon?: string;

   /**id de l'enregistrement */
   IconTooltip?: string;

   /**Indique si il est preselectionné */
   Preselected: boolean;

   /**
    * 
    * @param _iLabel Nom Affiché de l'enregistrement
    * @param _iShortName Nom  réduit  de l'enregistrement
    * @param _iId id unique de l'enregistrement
    * @param _iCode code de l'enregistrement
    * @param _iICon class de l'icone liée
    *  @param _iIConTooltip tooltip sur l'icone si présente
    * @param _iDescription description
    * @param _iSearchTerms terme complémentaire pour correspondre à la recherche (en plus du label - shortName)
    *  @param _iIsPreselected indique si il est préselectionné
    */
   constructor(_iLabel: string, _iShortName: string, _iId: string, _iCode: string, _iICon: string, _iIConTooltip: string, _iDescription: string, _iSearchTerms: string, _iIsPreselected: boolean = false) {
      this.Label = _iLabel;
      this.Short = _iShortName;
      this.Icon = _iICon;
      this.IconTooltip = _iIConTooltip
      this.Id = _iId;
      this.Code = _iCode;
      this.Description = _iDescription;
      this.Preselected = _iIsPreselected;
      this.SearchTerms = this.Label + _iSearchTerms;

   }
}